import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import Box from '@mui/material/Box'
import React, { useEffect, useState } from 'react'
import { a11yProps, TabPanel } from '../../components/BasicTab/BasicTab'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Button, TextField, Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { ruRU } from '@mui/x-date-pickers/locales';
import Statistics from '../../components/Statistics/Statistics'
import StatisticsRating from '../../components/StatisticsRating/StatisticsRating'
import { useGetStatisticsQuery, useGetStatisticsRatingQuery } from '../../store/statisticsAPI'
import { constURL } from '../../services/enum.services'
import { formatDate } from '../../utils/utils'
import { useAppDispatch, useAppSelector  } from '../../hooks/hooks'
import { FormControl, NativeSelect } from '@mui/material'
import { setStatisticAll, setStatisticRange } from '../../store/statisticsSlice'
import './StatisticsPage.scss'


dayjs.locale('ru');

// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

export const StatisticsPage = () => {                       // страница СТАТИСТИКИ
  const [value, setValue] = useState(0)
  const [firstDate, setFirstDate] = useState<Dayjs | null>(null)
  const [lastDate, setLastDate] = useState<Dayjs | null>(null)
  const [quesTheme, setQuesTheme] = useState('')
  const dispatch = useAppDispatch()
  const statisticType = useAppSelector(state => state.statisticsSlice?.type)


  const onClickTabStatisticAll = () => {
    dispatch(setStatisticAll());
  }

  const onClickTabStatisticRange = () => {
    dispatch(setStatisticRange());
  }


  // const [senderType, setSenderType] = useState<'Admin' | 'Water' | 'Web'>('Admin');


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue); 
    // if (newValue === 0) {
    //   setSenderType('Admin')
    // } else if (newValue === 1) {
    //   setSenderType('Water')
    // } else {
    //   setSenderType('Web')
    // }
  }

  const onChangeFirstDate = (value: Dayjs | null) => {           // выбор даты
    setFirstDate(value);
  }

  const onChangeLastDate = (value: Dayjs | null) => {           // выбор даты
    setLastDate(value);
  }

  const onChangeQuesTheme = (event: React.ChangeEvent<HTMLSelectElement>) => {                  // выбор темы
    setQuesTheme(event.target.value);     
  }

  const resetCalendar = () => {      // сброс фильтров
    setFirstDate(null);
    setLastDate(null);
    setQuesTheme('');
  }

  const {
    data: dataStats,
    isLoading,
    isFetching,
    error,
  } = useGetStatisticsQuery({                                                                 // передаем в запрос данные о статистике
    senderType: 'App',
    firstDate: formatDate(firstDate),
    lastDate: formatDate(lastDate),
    quesTheme: quesTheme,
  })

  const { data: dataStatsRating } = useGetStatisticsRatingQuery({                              // передаем в запрос данные о статистике ОЦЕНОК ответов на обращения                              
    firstDate: formatDate(firstDate),
    lastDate: formatDate(lastDate),
    quesTheme: quesTheme,
  })


  // useEffect(() => {
  //   console.log(
  //     `${constURL.STATISTICS}?senderType=${value === 0 ? 'Site' : 'App'}&firstDate=${formatDate(
  //       firstDate
  //     )}&lastDate=${formatDate(lastDate)}`
  //   );
  // }, [firstDate, lastDate, value]);


  const content = () => {
    if (isLoading || isFetching) {
      return 'Загрузка ...'
    }
    if (error) {
      return <h3>Ошибка загрузки</h3>
    }

    if (statisticType === 'StatisticAll') {
      // @ts-ignore
      return <Statistics {...dataStats} />
    } else if (statisticType === 'StatisticRating') {
    // @ts-ignore
      return <StatisticsRating {...dataStatsRating} />
    }
  return null;
}


  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <div className="period">
          <Typography variant="h6" component="h6" sx={{ margin: 1 }}>
            Выберите период:
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDayjs} localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
            <DatePicker
              className="filters-date__item"
              label="Начало периода"
              disableFuture
              value={firstDate}
              inputFormat="DD.MM.YYYY"
              views={['day', 'month', 'year']}
              mask="__.__.____"
              onChange={(newValue) => {
                onChangeFirstDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} variant="standard" id="fistDate" />}
            />
            <DatePicker
              className="filters-date__item"
              label="Конец периода"
              disableFuture
              value={lastDate}
              inputFormat="DD.MM.YYYY"
              onChange={(newValue) => {
                onChangeLastDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} variant="standard" id="lastDate" />}
            />
          </LocalizationProvider>
          <Button variant="contained" onClick={resetCalendar}>
            Сбросить фильтры
          </Button>
        </div>
        <div className="tabs-label">
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="tabs-wrapper">
            <Tab label="Статистика обращений" {...a11yProps(0)} onClick={onClickTabStatisticAll}/>
          </Tabs>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="tabs-wrapper">
            <Tab label="Оценка обращений" {...a11yProps(1)} onClick={onClickTabStatisticRange}/>
          </Tabs>
        </div>
      </Box>

      <FormControl style={{marginTop: 10, marginBottom: 10 }}>
        <div style={{marginBottom: 10 }}>Тема обращения:</div>
        <NativeSelect
          onChange={onChangeQuesTheme}
          value={quesTheme}
        >
          <option value="0">Все</option>
          <option value="akt_poverki">Акт замены, поверки ИПУ</option>
          <option value="statement">Выписка из лицевого счета</option>
          <option value="relationship">Договорные отношения</option>
          <option value="residents">Изменение количества проживающих</option>
          <option value="quality">Качество воды</option>
          <option value="service">Качество обслуживания потребителей</option>
          <option value="accrual">Начисления, перерасчёты</option>
          <option value="incorrectly_data">Некорректно внесены номер или дата поверки прибора учёта</option>
          <option value="cash_transfer">Перенос, возврат денежных средств</option>
          <option value="rebooking_ls">Переоформление лицевого счета</option>
          <option value="conversion_pay">Перерасчет размера платы за коммунальные услуги</option>
          <option value="connection">Подключение</option>
          <option value="appeal">Проблема с отправкой акта замены/поверки ИПУ</option>
          <option value="others">Прочее</option>  
          <option value="water">Работа систем водоснабжения</option>
          <option value="drains">Работа систем канализации</option>
          <option value="registration">Регистрация, авторизация, восстановление пароля</option>
          <option value="subsidy">Справка о начислениях и оплатах для оформления льгот, субсидий</option>
          <option value="spravka_debt">Справка об отсутствии задолженности</option>
          <option value="tariff">Тарифы, нормативы</option>
          <option value="devices">Установка, замена и поверка приборов учёта</option>
        </NativeSelect>
      </FormControl>
      <TabPanel value={value} index={0}>
        {content()}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {content()}
      </TabPanel>
    </Box>
  )
}